module.exports = __webpack_public_path__ + "CF.png?26f8c8ae810b3ff33522a2f995bd97bf";